import { Chip } from "@mui/material";
import { tierLabel, tierSlug, UNRATED } from "./competeDisplay";

export function TierBadge({
  tier,
  division,
  placed = true,
}: {
  tier: string;
  division?: number | null;
  /** False before placement: shows "Unrated", not the default tier. */
  placed?: boolean;
}) {
  if (!placed)
    return <Chip label={UNRATED} variant="outlined" size="small" />;
  const divisionText = division == null ? "" : `Division ${division}`;
  return (
    <Chip
      label={`${tierLabel(tier)}${divisionText ? ` ${divisionText}` : ""}`}
      data-tier={tierSlug(tier)}
      color="primary"
      variant="outlined"
      size="small"
    />
  );
}
